/**
 * Table of Contents Module.
 *
 * This will set the table of contents
 * links menu for articles based on the
 * h1 in the body.
 *
 * Since we have infinite scroll for the articles
 * we need to make suure each set
 * is referencing the correct article.
 *
 * This will be initialized inside the article
 * module.
 *
 * @param data
 */

/**
 * Include the dependencies.
 */
var $ = require("jquery");

/**
 * Set the Table of Contents Links.
 *
 */
var setToc = function($article_elem) {
  var $toc_items = $article_elem.find(
    "#article-body > .content > h1, #article-body > .content > h2, #article-body > .content > h3, .toc-heading"
  );

  var $toc_table = $article_elem.find(".toc-list");

  /**
   *
   * Finds the Table of content items added through the shortcode
   * and appends them in the table of content table
   */
  var $current_article_id = $article_elem.attr("id");

  if ($toc_table.length > 0 && $toc_items.length > 0) {
    for (var i = 0; i < $toc_items.length; i++) {
      $($toc_items[i]).attr("id", "toc-item-" + $current_article_id + "--" + i);
      $toc_table.append(
        '<li><a class="toc-anchor" href="#' +
          $($toc_items[i]).attr("id") +
          '">' +
          $($toc_items[i]).html() +
          "</a></li>"
      );
    }
  }

  $toc_table.find(".toc-anchor").on("click", function(e) {
    e.preventDefault();
    var href = $(this).attr("href");
    $(document).scrollTop($(href).offset().top - 50);
  });
};

/**
 * Export all of the methods.
 */
module.exports = {
  setToc: setToc
};
